import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelperService } from 'app/shared/dialogs/services/dialog-helper.service';
import { Subject } from 'rxjs';
import dxDataGrid from 'devextreme/ui/data_grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { DxDataGridComponent } from 'devextreme-angular';
@Injectable({
  providedIn: 'root',
})
export class ActionsService implements OnDestroy {
  private destroyed: Subject<void> = new Subject();
  constructor(
    private dialogHelperService: DialogHelperService,
    private translateService: TranslateService
  ) {}

  ngOnDestroy(): void {
    this.destroyed.next();
  }

  hasActionAccess(actionId: number): boolean {
    const enabledActions: number[] = JSON.parse(localStorage.getItem('enabledActions') || '') || [];

    if (enabledActions && enabledActions.length > 0 && enabledActions?.includes(actionId)) {
      return true;
    } else {
      this.dialogHelperService.notificationDialog(
        this.translateService.instant('confirm_messages.noAction')
      );
      return false;
    }
  }

  hasMenuAccess(actionId: number): boolean {
    const visibleMenus: number[] = JSON.parse(localStorage.getItem('visibleMenus') || '') || [];

    if (visibleMenus && visibleMenus.length > 0 && visibleMenus?.includes(actionId)) {
      return true;
    } else {
      return false;
    }
  }

  exportGridToExcel(
    dxGrid: dxDataGrid,
    fileName: string = 'DataGrid',
    selectedRowsOnly = false,
    customizeCell = () => {}
  ): void {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Data');

    exportDataGrid({
      component: dxGrid,
      selectedRowsOnly: selectedRowsOnly,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: customizeCell,
    }).then(() => {
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          this.translateService.instant(fileName) + '.xlsx'
        );
      });
    });
  }

  exportAsExcel(dataGrid?: DxDataGridComponent, b_selected_only: boolean = false): void {
    // if (!this.hasActionAccess(27)) return; TO DO add security

    if (dataGrid) this.exportGridToExcel(dataGrid.instance, 'DataGrid', b_selected_only);
  }

  onTextSearch(dataGrid?: DxDataGridComponent, val: string = ''): void {
    dataGrid?.instance.searchByText(val);
  }

  setMainImage(url: string) {
    document.documentElement.style.setProperty('--main-bg-image', `url("${url}")`);
  }

  setPopupImage(url: string) {
    document.documentElement.style.setProperty('--popup-bg-image', `url("${url}")`);
  }
}
